export enum ScreenPerformance {
  HOME = 'HomeOnlineScreen',
  SEARCH = 'SearchOnlineScreen',
  THEMATIC_HOME = 'ThematicHomeScreen',
  LOGIN = 'LoginScreen',
}
